require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/raw-loader/index.js!/home/runner/work/Core/Core/web/reviewportal/node_modules/jquery/dist/jquery.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery/dist/jquery.min.js
// module id = 584
// module chunks = 2